import React from "react";
import SortableItem from "./SortItem";

import { Button } from "reactstrap";

import {
  SortableContainer
} from "react-sortable-hoc";

const SortableList = SortableContainer(props => {
  let {
    items,
    removeItem,
    handleChange,
    itemsDisabled,
    canRemove,
    canAdd
  } = props;

  if (items) {
    return (
      <div className="list-container">
        {items.map((item, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            canRemove={canRemove}
            canAdd={canAdd}
            value={item.label}
            itemsDisabled={itemsDisabled}
            helperClass="dragging"
            sortIndex={index}
            removeItem={removeItem}
            handleChange={handleChange}
          />
        ))}
        {canAdd && (
          <Button
            className="add-button"
            size="sm"
            onClick={() => props.addNewRow()}
          >
            Add New
          </Button>
        )}
      </div>
    );
  } else {
    return <div />;
  }
});

export default SortableList;



// WEBPACK FOOTER //
// ./src/containers/CruiseLines/components/SortList.jsx